import axios from 'axios'
import { format, parse } from 'date-fns'

export const PRIZE_TYPES = {
  jackpot: 1,
  price: 2,
}

// state
export const state = {
  prizes: false,
  isPrizesLoading: false,
}

export const processPrize = prize => {
  let tmp = {
    ...prize,
    date: parse(prize.created_at),
    formattedDate: format(parse(prize.created_at), 'D.M.YYYY'),
    expirationDate: parse(prize.expirationDate),
    type: prize.win_type,
    currency: process.env.VUE_APP_CURRENCY_SYMBOL,
    roundId: prize.round_id,
  }
  delete tmp.created_at
  delete tmp.win_type
  delete tmp.round_id
  return tmp
}

// mutations
export const getters = {
  getPrizeByRound: ({ prizes }) => searchRoundId => prizes && prizes.find(({ roundId }) => roundId === searchRoundId),
}

// mutations
export const mutations = {
  fetchPrizesStarted(state) {
    state.isPrizesLoading = true
  },
  fetchPrizesSuccess(state, { prizes }) {
    state.prizes = prizes.map(prize => processPrize(prize))
    state.isPrizesLoading = false
  },
  fetchPrizesFailed(state) {
    state.isPrizesLoading = false
  },
  setPrizeStatus(state, { prizeId, status }) {
    state.prizes = state.prizes.map(prize => {
      if (prize.id === prizeId) {
        prize.status = status
      }
      return prize
    })
  },
}
// actions
export const actions = {
  async fetchPrizes({ commit, state }) {
    let prizes = state.prizes
    if (!prizes) {
      try {
        commit('fetchPrizesStarted')
        prizes = await axios.get(`wins`)
        commit('fetchPrizesSuccess', { prizes })
      } catch (e) {
        commit('fetchPrizesFailed')
      }
    }
    return prizes
  },
}
